export const THEME_COLORS = {
  primary: [
    '#eef6fc',
    '#e3e8ec',
    '#c7ced4',
    '#a7b3bc',
    '#8d9ca8',
    '#7c8e9c',
    '#728797',
    '#5f7484',
    '#536878',
    '#42596b'
  ]
} as const;
